var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vditor","contentValue":_vm.contentValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }